import React from 'react'

function Tecnologias() {
    return (
        <div className="todo_skills">
            <div id="skills">
                <div className="titulo_skills titulo_tecnologias">
                    <h3>TECNOLOGÍAS</h3>
                </div>
                <div className="skills">
                    <div className='primera_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                C# .Net
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Visual Basic .Net
                            </div>
                        </div>
                    </div>
                    <div className='segunda_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Entity Framework
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                SQL Server
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skills">
                    <div className='primera_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                HTML
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                CSS
                            </div>
                        </div>
                    </div>
                    <div className='segunda_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                JavaScript
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Vue.js
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skills">
                    <div className='primera_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                React.js
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                TypeScript
                            </div>
                        </div>
                    </div>
                    <div className='segunda_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                PHP
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Node.js
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skills">
                    <div className='primera_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Java
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Spring Boot
                            </div>
                        </div>
                    </div>
                    <div className='segunda_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                FireBase
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Azure
                            </div>
                        </div>
                    </div>
                </div>
                <div className="skills">
                    <div className='primera_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                MySQL
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Visual Studio
                            </div>
                        </div>
                    </div>
                    <div className='segunda_fila_skills fila_tecnologias'>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Visual Studio Code
                            </div>
                        </div>
                        <div className="skill tecnologia">
                            <div className="titulo_skill">
                                Git & GitHub
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Tecnologias
